import type { FormVariant } from "@shared/types";
import type { HandleChangeValue } from "../types";

export type { HandleChangeValue };

export const handleBagSizeChange = ({
  key,
  value,
  singleBagSize,
  handleSetSingleBagSize,
}: {
  key: string;
  value: HandleChangeValue;
  singleBagSize: string | undefined;
  handleSetSingleBagSize: (bagSize: string | undefined) => void;
}) => {
  if (key.includes("bagSize") && (!singleBagSize || singleBagSize !== value) && typeof value === "string") {
    handleSetSingleBagSize(value);
  }
};

export const handleIsProductSelectedForImportChange = ({
  key,
  value,
  currentVariant,
  singleBagSize,
  variants,
  handleSetSingleBagSize,
  handleChange,
  index,
}: {
  key: string;
  value: HandleChangeValue;
  currentVariant: FormVariant | undefined;
  singleBagSize: string | undefined;
  variants: FormVariant[] | undefined;
  handleSetSingleBagSize: (bagSize: string | undefined) => void;
  handleChange: (key: string) => (value: HandleChangeValue) => void;
  index: number;
}) => {
  // If the isProductSelectedForImport field is changed to true, and the current variant has a bag size, and the singleBagSize is not set, then set the singleBagSize to the current variant's bag size
  if (key.includes("isProductSelectedForImport")) {
    const bagSize = currentVariant?.mapDetectedBagSizeTo ?? currentVariant?.bagSize;
    if (value === true && bagSize && !singleBagSize) {
      handleSetSingleBagSize(bagSize);
    }
    if (value === false) {
      const otherVariantsSelected = variants?.some((variant) => {
        return currentVariant !== variant && variant.isProductSelectedForImport;
      });
      if (!otherVariantsSelected) {
        handleSetSingleBagSize(undefined);
      }
      if (!currentVariant?.hasDetectedBagSize) {
        handleChange(`variants[${index}].bagSize`)("");
      }
    }
  }
};

export const setVariantChange =
  (
    variants: FormVariant[] | undefined,
    isSingleBagSizeEnabled: boolean,
    previousImportedBagSizes: string | string[] | undefined,
    singleBagSize: string | undefined,
    handleSetSingleBagSize: (bagSize: string | undefined) => void,
    handleChange: (key: string) => (value: HandleChangeValue) => void
  ) =>
  (key: string, index: number) =>
  (value: HandleChangeValue) => {
    const currentVariant = variants?.[index];
    if (!isSingleBagSizeEnabled || previousImportedBagSizes) {
      handleChange(key)(value);
    } else {
      handleBagSizeChange({
        key,
        value,
        singleBagSize,
        handleSetSingleBagSize,
      });
      handleIsProductSelectedForImportChange({
        key,
        value,
        currentVariant,
        singleBagSize,
        variants,
        handleSetSingleBagSize,
        handleChange,
        index,
      });
      handleChange(key)(value);
    }
  };
